import React from "react";
import { Link } from "gatsby";

const PageLink = ({ page, switchRef, linkText, children, ...rest }) => {
  return (
    <Link ref={switchRef} to={`/${page?.slug?.current}`} {...rest}>
      {linkText || children}
    </Link>
  );
};

export default PageLink;
